import {css} from 'styled-components';
import logoFkh from './icons/fkh/logo-fkh.svg';
import progress1 from './icons/fkh/step-indicator-1.svg';
import progress2 from './icons/fkh/step-indicator-2.svg';
import progress3 from './icons/fkh/step-indicator-3.svg';
import progress1of2 from './icons/fkh/step-indicator-1of2.svg';
import progress2of2 from './icons/fkh/step-indicator-2of2.svg';
import whatsapp from './icons/sho/whatsapp.png';
import facebook from './icons/sho/facebook.svg';
import twitter from './icons/sho/x.svg';
import linkedin from './icons/sho/linkedin.svg';
import instagram from './icons/sho/instagram.svg';

// Palette taken from kinderhulp.nl: navy text and default buttons, red-orange call-to-action, green checkmarks, light-blue form backgrounds
const navy = '#001636';
const red = '#EF4123';
const redDark = '#D02B0F';
const green = '#48AC83';
const lightBlue = '#EDF8F9';
const textGrey = '#666666';
const borderColor = '#D8D8D8';
const inputBorderColor = '#999999';
const placeholderColor = '#999999';
const focusRing = 'rgba(0, 22, 54, 0.15)';
const errorColor = '#CC4B37';

const bodyFont = '"Open Sans", Arial, sans-serif';

export default {
  // GlobalStyles
  bodyFontFamily: bodyFont,
  h1FontFamily: bodyFont,
  h3FontFamily: bodyFont,
  h1FontSize: '26px',
  h1FontColor: navy,
  bodyFontSize: '16px',
  bodyFontColor: navy,
  linkHoverColor: red,
  background: css`
    background-image: ${props => `url('${props.backgroundImageUrl}')`};
    background-repeat: no-repeat;
    background-position: center;
    background-attachment: fixed;
    background-color: ${lightBlue};
    position: fixed;
    top: -10px;
    left: -10px;
    bottom: -10px;
    right: -10px;
    z-index: -10;
    background-size: cover;

    @media (min-width: 769px) and (max-width: 1024px) {
      background-image: ${props => `url('${props.backgroundImageTabletUrl}')`};
      background-position-y: top;
      background-position-x: left;
      background-attachment: local;
      left: -240px;
    }

    @media (max-width: 768px) {
      background-image: ${props => `url('${props.backgroundImageMobileUrl}')`};
      width: 100%;
      height: 100%;
      background-color: white;
      background-size: contain;
      background-position-y: top;
      background-position-x: center;
      background-repeat: no-repeat;
      inset: initial;
      z-index: -1;
      background-attachment: local;
      position: absolute;
    }
  `,
  // AmountButton
  amountButton: {
    color: '#fff',
    inactiveColor: navy,
    fontFamily: bodyFont,
    fontSize: '18px',
    fontWeight: '700',
    width: 'calc(50% - 6.5px)',
    height: '56px',
    border: `1px solid ${borderColor}`,
    borderRadius: '0',
    backgroundColor: '#fff',
    backgroundColorActive: navy,
    borderHover: `1px solid ${navy}`,
    boxShadowHover: `inset 0px 0px 0px 1px ${navy}`
  },
  frequencyButton: {
    color: '#fff',
    inactiveColor: navy,
    fontFamily: bodyFont,
    fontSize: '18px',
    fontWeight: '700',
    width: 'calc(50% - 6.5px)',
    height: '56px',
    border: `1px solid ${borderColor}`,
    borderRadius: '0',
    backgroundColor: '#fff',
    backgroundColorActive: navy,
    borderHover: `1px solid ${navy}`,
    boxShadowHover: `inset 0px 0px 0px 1px ${navy}`
  },
  buttonContainerSpaceBetween: {
    width: '30%'
  },
  frequencyButtonContainer: {
    width: '30%'
  },
  // BackButton
  backButton: {
    fontSize: '14px',
    color: red
  },
  // Box
  boxComponent: {
    borderRadius: '8px',
    border: 'none',
    shadow: '0 8px 24px 0 rgba(0, 22, 54, 0.15)'
  },
  // Button
  button: {
    borderRadius: '0',
    fontFamily: bodyFont,
    fontSize: '18px',
    fontWeight: '700',
    height: '56px',
    backgroundColor: red,
    color: '#fff',
    boxShadow: 'none',
    transition: 'background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease',
    active: css`
      background-color: ${navy};
      border-color: ${navy};
      color: #fff;
      box-shadow: none !important;
    `,
    hover: css`
      background-color: ${redDark};
      border-color: ${redDark};
      color: #fff;
    `,
    focus: css`
      box-shadow: 0 0 0 3px ${focusRing};
    `
  },
  // Checkbox
  inputCheckbox: {
    border: `1px solid ${inputBorderColor}`,
    borderRadius: '0'
  },
  box: {
    fontSize: '14px',
    colorHasError: errorColor,
    borderHasError: `1px solid ${errorColor}`,
    borderHover: `1px solid ${navy}`,
    backgroundColorChecked: green,
    backgroundBorderChecked: `1px solid ${green}`
  },
  // Collecting
  collecting: {
    imageTopRight: true,
    height: '60px',
    heightMobile: '60px',
    margin: '30px 16px 20px 0',
    marginMobile: '30px 16px 20px 0'
  },
  // DateInput
  dateDropdown: {
    padding: '10px 30px 12.4px 10px',
    border: `1px solid ${inputBorderColor}`,
    borderRadius: '0',
    borderFocus: `1px solid ${navy}`,
    boxShadowFocus: `0 0 0 3px ${focusRing}`,
    borderError: `1px solid ${errorColor}`,
    boxShadowError: 'none',
    borderValid: `1px solid ${inputBorderColor}`,
    boxShadowValid: 'none'
  },
  // DisplayIban
  iban: {
    fontFamily: bodyFont,
    color: '#fff'
  },
  // Dropdown
  dropdown: {
    height: '46px',
    borderRadius: '0',
    backgroundColor: '#fff',
    fontSize: '16px',
    paddingLeft: '13px',
    border: `1px solid ${inputBorderColor}`,
    borderFocus: `1px solid ${navy}`,
    boxShadow: 'none',
    boxShadowFocus: `0 0 0 3px ${focusRing}`,
    boxShadowError: `0 0 0 1px ${errorColor}`,
    boxShadowValid: 'none'
  },
  // ErrorMessage
  error: {
    backgroundColor: '#FBECEC',
    color: errorColor,
    height: '49px'
  },
  // Iban
  ibanContainer: {
    display: 'none'
  },
  // Input
  inputComponent: {
    fontSize: '16px',
    color: navy,
    border: `1px solid ${inputBorderColor}`,
    borderRadius: '0',
    borderHover: `1px solid ${navy}`,
    boxShadowHover: 'none',
    borderFocus: `1px solid ${navy}`,
    boxShadowFocus: `0 0 0 3px ${focusRing}`,
    colorPlaceholder: placeholderColor,
    borderValid: `1px solid ${inputBorderColor}`,
    boxShadowValid: 'none',
    backgroundColorValid: '#fff',
    borderError: `1px solid ${errorColor}`,
    boxShadowError: 'none',
    colorError: errorColor,
    backgroundColorError: '#FFF5F5'
  },
  // TextArea
  textAreaComponent: {
    fontSize: '16px',
    color: navy,
    border: `1px solid ${inputBorderColor}`,
    borderRadius: '0',
    borderHover: `1px solid ${navy}`,
    boxShadowHover: 'none',
    borderFocus: `1px solid ${navy}`,
    boxShadowFocus: `0 0 0 3px ${focusRing}`,
    colorPlaceholder: placeholderColor,
    borderValid: `1px solid ${inputBorderColor}`,
    boxShadowValid: 'none',
    backgroundColorValid: '#fff',
    borderError: `1px solid ${errorColor}`,
    boxShadowError: 'none',
    colorError: errorColor,
    backgroundColorError: '#FFF5F5'
  },
  // Label
  optionalLabel: {
    color: textGrey
  },
  label: {
    fontSize: '14px',
    fontWeight: '700',
    color: navy,
    colorError: errorColor
  },
  logo: {
    width: '88px',
    height: '60px',
    backgroundImage: logoFkh,
    widthMobile: '88px',
    heightMobile: '60px',
    margin: '30px 0 20px 0',
    marginMobile: '30px 0 20px 16px'
  },
  // PaymentButton
  paymentButton: {
    color: navy,
    fontFamily: bodyFont,
    fontSize: '11px',
    width: 'calc(36% - 10px)',
    height: '56px',
    lineHeight: '45px',
    border: `1px solid ${borderColor}`,
    borderRadius: '0',
    backgroundColor: '#fff',
    backgroundColorActive: lightBlue,
    borderHover: `1px solid ${navy}`,
    boxShadowHover: `inset 0px 0px 0px 1px ${navy}`
  },
  // ProgressBar
  progressBar: {
    step1: css`
      width: 70px;
      background: url(${progress1}) no-repeat 0;
    `,
    step2: css`
      width: 70px;
      background: url(${progress2}) no-repeat 0;
    `,
    step3: css`
      width: 70px;
      background: url(${progress3}) no-repeat 0;
    `,
    step1of2: css`
      width: 40px;
      background: url(${progress1of2}) no-repeat 0;
    `,
    step2of2: css`
      width: 40px;
      background: url(${progress2of2}) no-repeat 0;
    `
  },
  // RadioButton
  inputRadioButton: {
    fontSize: '16px',
    backgroundColor: '#fff',
    border: `1px solid ${inputBorderColor}`,
    backgroundColorDisabled: borderColor,
    backgroundColorActive: green,
    borderActive: `1px solid ${green}`,
    borderDisabled: `1px solid ${borderColor}`
  },
  radio: {
    borderHover: `1px solid ${navy}`,
    colorHasError: errorColor,
    borderHasError: `1px solid ${errorColor}`
  },
  // TeaserHeader
  teaser: {
    hideOnMobile: true,
    display: 'inline',
    fontFamily: bodyFont,
    fontWeight: '800',
    fontSize: '32px',
    lineHeight: '46px',
    color: '#fff',
    backgroundColor: red,
    colorSubtitle: navy,
    backgroundColorSubtitle: '#fff',
    padding: '3px 10px',
    fontSizeTablet: '28px',
    lineHeightTablet: '42px',
    fontSizeWide: '36px',
    lineHeightWide: '50px',
    subtitleFontFamily: bodyFont,
    subtitleFontSize: '18px',
    subtitleLineHeight: '31px',
    subtitleFontSizeWide: '18px',
    subtitleLineHeightWide: '31px',
    subtitleFontSizeTablet: '18px',
    subtitleLineHeightTablet: '31px',
    paddingTop: '0',
    topLeftTextAlignment: 'left',
    topRightTextAlignment: 'right',
    bottomLeftTextAlignment: 'left',
    bottomRightTextAlignment: 'right'
  },
  teaserContainer: {
    margin: '10px 0 0 0'
  },
  // Title
  title: {
    color: '#fff',
    fontFamily: bodyFont,
    fontSize: '20px',
    height: '64px',
    fontWeight: '800',
    borderRadius: '8px',
    backgroundColor: navy,
    widthProperty: 'max-width: 280px;'
  },
  // Validation
  validation: {
    color: errorColor,
    fontSize: '14px'
  },
  // OptIn
  optInButton: {
    fontFamily: bodyFont,
    fontSize: '18px',
    borderRadius: '0',
    backgroundColor: red,
    color: '#fff',
    boxShadow: 'none',
    active: css`
      background-color: ${navy};
      border-bottom: none;
      box-shadow: none !important;
    `,
    hover: css`
      background-color: ${redDark};
    `,
    focus: css`
      box-shadow: 0 0 0 3px ${focusRing};
    `
  },
  // PersonalMessage
  personalMessage: {
    fontFamily: bodyFont,
    fontSize: '18px',
    buttonFontSize: '18px',
    backgroundColor: lightBlue,
    color: navy,
    boxShadow: 'none',
    active: css`
      border-bottom: none;
      box-shadow: none !important;
    `,
    focus: css`
      box-shadow: none;
    `,
    checkmarkColor: green
  },
  // SocialShareButton
  socialShareButton: {
    backgroundSize: '50px',
    color: navy,
    whatsapp: css`background-image: url(${whatsapp})`,
    facebook: css`background-image: url(${facebook})`,
    twitter: css`background-image: url(${twitter})`,
    linkedin: css`background-image: url(${linkedin})`,
    instagram: css`background-image: url(${instagram})`
  },
  privacyLabel: {
    standard: {
      fontSize: '12px'
    }
  },
  amountText: {
    boldFrequency: true
  }
};
